module.exports = __webpack_public_path__ + "static/Baggage-first-iteration-589cb79d3a4ed7135759d0e00b87adbd.png";